var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "client-details-card",
      "store-path": "clientProfileDetails",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("client-profile.profileDetails"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "form",
              {
                ref: "form",
                staticClass: "row justify-content-center",
                attrs: {
                  id: "client-profile-details-form",
                  autocomplete: "off",
                },
                on: {
                  change: _vm.saveOnType,
                  submit: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12 m-0",
                    attrs: { id: "personal-details-container" },
                  },
                  [
                    _vm.loading
                      ? _c("client-profile-details-loader")
                      : [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("material-input", {
                                  attrs: {
                                    label: _vm.$t("account.givenName"),
                                    "label-for": "profile-details-firstName",
                                  },
                                  model: {
                                    value: _vm.givenName,
                                    callback: function ($$v) {
                                      _vm.givenName = $$v
                                    },
                                    expression: "givenName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("material-input", {
                                  attrs: {
                                    label: _vm.$t("account.familyName"),
                                    "label-for": "profile-details-lastName",
                                  },
                                  model: {
                                    value: _vm.familyName,
                                    callback: function ($$v) {
                                      _vm.familyName = $$v
                                    },
                                    expression: "familyName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row no-gutters align-items-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c("material-input", {
                                    attrs: {
                                      label: _vm.$t("account.email"),
                                      "label-for": "profile-details-email",
                                      type: "email",
                                    },
                                    model: {
                                      value: _vm.email,
                                      callback: function ($$v) {
                                        _vm.email = $$v
                                      },
                                      expression: "email",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-auto pb-3" }, [
                                _c(
                                  "a",
                                  {
                                    class: { disabled: !_vm.email },
                                    attrs: {
                                      href: _vm.email
                                        ? "mailto:" + _vm.email
                                        : null,
                                      "aria-label": "first link",
                                    },
                                  },
                                  [
                                    _c("icon", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: {
                                            title: _vm.$t(
                                              "global.actions.sendExternalEmail"
                                            ),
                                            disabled: !_vm.email,
                                            placement: "right",
                                          },
                                          expression:
                                            "{\n                    title: $t('global.actions.sendExternalEmail'),\n                    disabled: !email,\n                    placement: 'right'\n                  }",
                                        },
                                      ],
                                      staticClass: "text-light-gray",
                                      attrs: { name: "envelope-o" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "material-input",
                                  {
                                    attrs: {
                                      label: _vm.$t("account.phoneNumber"),
                                      "label-for": "profile-details-phone",
                                    },
                                  },
                                  [
                                    _c("phone-input", {
                                      staticClass:
                                        "material-input form-control form",
                                      class: {
                                        "form-control-filled": _vm.phoneNumber,
                                      },
                                      attrs: {
                                        id: "profile-details-phone",
                                        name: "phoneNoFill",
                                        title: _vm.$t(
                                          "account.form.validPhoneNumber"
                                        ),
                                        type: "text",
                                        "data-lpignore": "true",
                                        "emit-value": true,
                                        value: _vm.phoneNumber,
                                      },
                                      on: {
                                        change: function (val) {
                                          return (_vm.phoneNumber = val)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "material-input",
                                  {
                                    attrs: {
                                      label: _vm.$t("account.birthDate"),
                                    },
                                    model: {
                                      value: _vm.dateOfBirth,
                                      callback: function ($$v) {
                                        _vm.dateOfBirth = $$v
                                      },
                                      expression: "dateOfBirth",
                                    },
                                  },
                                  [
                                    _c("datepicker-input", {
                                      attrs: {
                                        id: "profile-details-birthday",
                                        label: _vm.$t("account.birthDate"),
                                        name: "date-of-birth",
                                        "past-date": "",
                                      },
                                      on: { change: _vm.saveOnType },
                                      model: {
                                        value: _vm.dateOfBirth,
                                        callback: function ($$v) {
                                          _vm.dateOfBirth = $$v
                                        },
                                        expression: "dateOfBirth",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("server-side-referrers-select", {
                                  attrs: {
                                    id: "profile-details-referrers-select",
                                    "label-key":
                                      "client-profile.participants.referrerOnly",
                                    "pre-selected-referrer":
                                      _vm.referrerSelected,
                                  },
                                  on: {
                                    change: _vm.updateReferrer,
                                    "handle-referrer": _vm.handleReferrer,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown col-12 pb-2 d-flex justify-content-end align-items-center",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "dropdown-toggle btn btn-primary btn-sm",
                                    attrs: {
                                      "data-toggle": "dropdown",
                                      type: "button",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "referrers.actions.referrerActions"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-menu",
                                    attrs: {
                                      "aria-labelledby": "dropdownMenuButton",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item clickable toggle-referrer",
                                        attrs: { id: "dropdownMenuButton" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openReferrersModal()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "referrers.actions.addNewReferrer"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item clickable toggle-referrer",
                                        class: { disabled: _vm.emptyReferrer },
                                        attrs: { disabled: _vm.emptyReferrer },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openReferrersModal(
                                              _vm.referrerId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "referrers.actions.editSelectedReferrer"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "material-input",
                                  {
                                    attrs: {
                                      label: _vm.$t("global.words.value"),
                                      "label-for": "personal-details-value",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.value,
                                          expression: "value",
                                        },
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: _vm.mask,
                                          expression: "mask",
                                        },
                                      ],
                                      staticClass:
                                        "material-input form-control form form-control-filled",
                                      attrs: {
                                        id: "personal-details-value",
                                        "data-lpignore": "true",
                                        placeholder: "0",
                                        type: "text",
                                      },
                                      domProps: { value: _vm.value },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.value = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }